
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import SlideContainer from 'components/SlideContainer'
import NotifyContent from 'components/NotifyContent'
import {closeModal} from 'redux/modules/ui/modal/actions'
import bellImage from 'components/Icon/images/bell.svg'

export class NotifyView extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func
  }
  render() {
    const {closeModal} = this.props
    return (
      <SlideContainer
        className='notify_view'
        title='Notifications'
        icon={bellImage}
        width={800}
        onCloseModal={closeModal}
      >
        <NotifyContent onFullPage={false} showFilter={false} />
      </SlideContainer>
    )
  }
}

export default connect(null, {
  closeModal
})(NotifyView)



// WEBPACK FOOTER //
// ./client/modals/NotifyView/index.js